module.exports = __webpack_public_path__ + "static/media/smartbuy.63a8dd7f.gif";